import axios from '../api/axios';

export async function carHouseAdmins(carHouseId, options = {}) {
  const response = await axios.get(`/carHouses/${carHouseId}/admins`, options);

  return response.data;
}

export async function getCarHouseAdminById(carHouseId, carHouseAdminId) {

  const res = await axios.get(`/carHouses/${carHouseId}/admins/${carHouseAdminId}`)
  return res;
}

export async function createCarHouseAdmin(carHouseId, body) {
  const response = await axios.post(
    `/carHouses/${carHouseId}/admins`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function updateCarHouseAdmin(carHouseId, carHouseAdminId, body) {
  const response = await axios.patch(
    `/carHouses/${carHouseId}/admins/${carHouseAdminId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function deleteCarHouseAdmin(carHouseId, carHouseAdminId) {
  await axios.delete(`/carHouses/${carHouseId}/admins/${carHouseAdminId}`);

  return carHouseAdminId;
}
